export const GOBI_CUSTOM_MAPPINGS_API = 'gobi/orders/custom-mappings';
export const GOBI_MAPPINGS_API = 'gobi/orders/mappings';
export const ORDER_FIELDS_API = `${GOBI_MAPPINGS_API}/fields`;
export const ORDER_MAPPING_TYPES_API = `${GOBI_MAPPINGS_API}/types`;
export const ORDER_TRANSLATORS_API = `${GOBI_MAPPINGS_API}/translators`;
